<template>
  <o-view :no-scroll="true">
    <o-view :bottom-padding="true" :flex="true">
      <o-nav-bar title="Cambio" :has-back-button="true" />
      <o-empty-state
        icon="car"
        label="Je hebt nog geen Cambio-wagens gereserveerd."
      />
    </o-view>
    <o-pay-button
      label="Nieuwe reservatie"
      to="/sales/car/cambio/reservations/new"
    />
  </o-view>
</template>

<script>
import OEmptyState from '@/components/OEmptyState.vue'
import OPayButton from '@/components/OPayButton.vue'

export default {
  name: 'CambioReservations',
  components: {
    OEmptyState,
    OPayButton
  }
}
</script>
